import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import { paymentReducer, initialState } from './payment.reducer';
import { PaymentContextType } from './payment.types';

const PaymentContext = createContext<PaymentContextType | undefined>(undefined);

export const PaymentProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(paymentReducer, initialState);

  return <PaymentContext.Provider value={{ state, dispatch }}>{children}</PaymentContext.Provider>;
};

export const usePaymentContext = () => {
  const context = useContext(PaymentContext);
  if (context === undefined) {
    throw new Error('usePaymentContext must be used within a PaymentProvider');
  }
  return context;
};
